import { Component, ViewChild } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';
import { Diagnostic } from '@ionic-native/diagnostic';
import { AndroidPermissions } from '@ionic-native/android-permissions';

import { UserMyRadiant as User } from '../../../providers/';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, PermitProvider, ApiMyRadiant} from '../../../providers/';
import { CalendarResult } from 'ion2-calendar';
import { cmpFilterKaryawan } from '../../../components/presensi';
import { AddPermit } from '../add_permit/page';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '../../../providers/resources/utility';
import { TabsPage } from '../../dashboard';
import { UserPresensi } from '../../../providers/presensi';

@Component({
  selector: 'presensi-permit',
  templateUrl: 'page.html'
})
export class Permit {
  berita:any = '';
  loading : any;
  isLogin : any = 0;
  fitur = this.userPresensi.akses;
  data = {
    permit:[{}],
    permitBawahan:[],
    verification:'',
    dateMulai:"",
    dateAkhir:"",
    dateJarak:"",
  };
  state = {
    showList : 'me',
    addPermit : true,
    searching : false,
  };
  akses = this.userPresensi.akses;
  startDate:any = new Date;
  valDateJarak:any;
  today = this.helper.getToday();
  parameter : any = {
    id  : this.userApi.data.Employee_ID,
    nik : this.userApi.data.NIK,
    date_start : this.today.awalYmd,
    date_end : this.today.akhirYmd,
    search : '',
    filter_data_permit:'',
    verification : {
      id : null,
      action : null,
      id_karyawan :this.userApi.data.Employee_ID,
      nama_karyawan : this.userApi.data.Nama_Karyawan,
      verificator:'',
      filter_data:'',
    }
  }
  fileTransfer: FileTransferObject = this.transfer.create();
  @ViewChild('slidingItem') private itemSliding: ItemSliding;
  @ViewChild('contentSlide') private contentSliding: Item;
  @ViewChild('widgetSearch') private searchBar: Searchbar;

  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    private permitProvider: PermitProvider, 
    private photoViewer   : PhotoViewer,
    private file          : File,
    private transfer      : FileTransfer,
    private events        : Events,
    private userPresensi  : UserPresensi,
    public navParams      : NavParams,
    private diagnostic    : Diagnostic,
    private androidPermissions: AndroidPermissions,
  ) {
    this.valDateJarak = {
  		from:this.today.obj.awal,
  		to:this.today.obj.akhir
    };
    this.parameter.filter_data_permit = this.fitur.lihat_data_bawahan_permit_group_data;
    this.parameter.verification.verificator = this.fitur.lihat_data_bawahan_permit_group_data;
    let isNotification = this.navParams.get('isNotification');
    if (isNotification) {
      this.showKaryawan();
    }else{
      this.getPermit();
    }
  }

  ionViewWillEnter(){
    if (this.utility.buildApk) {
      this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.LOCATION).then(
        result => console.log('Has permission?', result.hasPermission),
        err    => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.LOCATION)
      );
    }
  }

  getPermit(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.repositoryProvider.getListPermit(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.permit = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getListPermitBawahan(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.repositoryProvider.getListPermitBawahan(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.permitBawahan = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }
 
  showKaryawan(){
    let me = this;
    // this.loading = this.helper.showLoading('Loading Data..');
    if(me.state.showList == 'me'){
      me.state.showList = 'bawahan';
      me.state.searching = true;
      me.data.verification = '(Verification)';
      me.getListPermitBawahan();
      me.state.addPermit = false;
    }else{
      me.state.showList = 'me';
      me.data.verification = '';
      me.state.addPermit = true;
      me.state.searching = false;
      me.getPermit();
    }
    
  }

  openCalendar() {
    let me = this;
    this.helper.valDateJarak = this.valDateJarak;
    this.helper.openCalendar((data,role) => {

      if (role=="done") {
        let date = data;
        let from: CalendarResult = date.from;
        let to: CalendarResult = date.to;	
          this.startDate = from.dateObj;
          this.parameter.date_start = from.string;
          this.parameter.date_end = to.string;
          this.data.dateJarak = this.helper.dateToString(from.dateObj) + ' s/d ' + this.helper.dateToString(to.dateObj);
          me.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          }
          this.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          };
          (me.state.showList) == 'me' ? me.getPermit() : me.getListPermitBawahan();
          
      }
    })  
  }

  addPermit(){
    let me = this;
    if (this.utility.debugMode) {
      me.nav.push(AddPermit);
    }else{
      this.diagnostic.isGpsLocationEnabled()
        .then((state) => {
          if (state){
            // do something
            me.nav.push(AddPermit);
          } else {
            // do something else
            let optionsSwal = {
                title:"Information",
                desc:"This Feature Requires Your Location. Please check your GPS settings again.",
                icon:"",
                dangerMode:false,
                btnCancel:"Later",
                btnConfirm:"Setting",
              }
            this.helper.presentSwalConfirmation(optionsSwal,() => {
              //success callback
              this.diagnostic.switchToLocationSettings();
            })
            
          }
        }).catch(e => console.error(e));
    }
  }

  addPermitBawahan(){
    let me = this;
    if (this.utility.debugMode) {
      me.nav.push(AddPermit,{
        with_employee : true,
      });
    }else{
      this.diagnostic.isGpsLocationEnabled()
        .then((state) => {
          if (state){
            // do something
            me.nav.push(AddPermit);
          } else {
            // do something else
            let optionsSwal = {
                title:"Information",
                desc:"This Feature Requires Your Location. Please check your GPS settings again.",
                icon:"",
                dangerMode:false,
                btnCancel:"Later",
                btnConfirm:"Setting",
              }
            this.helper.presentSwalConfirmation(optionsSwal,() => {
              //success callback
              this.diagnostic.switchToLocationSettings();
            })
            
          }
        }).catch(e => console.error(e));
    }
    // let params = {
    //   id: this.userApi.data.Employee_ID,
    //   all_data : true,
    // };
    // this.helper.filterKaryawan(params, (karyawan) => {
    //   me.nav.push(AddPermit,{
    //     bawahan : true,
    //     employee_id : karyawan.id
    //   });
    // });
  }

  confirmVerification(state,permit) {
    let me = this;
    const confirm = this.alertCtrl.create({
      title: 'Confirm Verification',
      message: 'Are you sure ?',
      buttons: [
        {
          text: 'No',
          handler: () => {

          }
        },
        {
          text: 'Yes',
          handler: () => {
            me.parameter.verification.id = permit.ID_PERMIT;
            me.parameter.verification.action = state;
            me.parameter.verification.filter_data = permit.FILTER_DATA_PERMIT;
            this.verificationAction();
          }
        }
      ]
    });
    confirm.present();

  }

  verificationAction(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.permitProvider.verficationAction(this.parameter.verification).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
       me.getListPermitBawahan();
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
    
  } 

  showSearch(){
    this.state.searching = false; 
    this.searchBar._fireFocus();
    
    setTimeout(() => {
      this.searchBar.setFocus();
      this.searchBar._animated;
      console.log(this.state.searching);
    }, 500);
  }
  cancelSearch(){
    this.state.searching = true; 
    this.searchBar._fireBlur();
    setTimeout(() => {
      this.searchBar.inputBlurred();
    }, 500);
  }

  previewAttachment(file){
    // console.log(this.api.url+file);
    this.photoViewer.show(this.api.url+file);
  }
  downloadAttachment(file,name_real) {
    const url = this.api.url+file;
    this.loading = this.helper.showLoading("Downloading...");
    let direktori = this.utility.getDirMyRadiant();
    this.fileTransfer.download(url, direktori + name_real,true).then((entry) => {
      try {
        this.loading.dismiss();
        this.helper.presentSwal('Success','Download Complete. Your file has saved in '+entry.toURL());
      } catch (error) {}
    }, (error) => {
      // handle error
      console.log(error);
      try {
        this.loading.dismiss();
        
        this.helper.presentSwal('Failed','Error Download File. Check your connection and try again.','error');
      } catch (error) {}
    });
  }
  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }
}



// WEBPACK FOOTER //
// ./src/pages/presensi/permit/page.ts